export default __webpack_public_path__ + "static/media/calendar-plus.d2f5db6a.svg";